import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=23287ed4&scoped=true&"
import script from "./Transfers.vue?vue&type=script&lang=js&"
export * from "./Transfers.vue?vue&type=script&lang=js&"
import style0 from "./Transfers.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Transfers.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Transfers.vue?vue&type=style&index=2&id=23287ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23287ed4",
  null
  
)

export default component.exports